import { useQuery } from "@tanstack/react-query"

import { getConfiguracionNotificaciones } from "../services/notificaciones.service";

export const useConfiguracionNotificaciones = () => {

    const configuracionNotificacionesQuery = useQuery({
        queryKey: ['configuracionNotificaciones'],
        queryFn: () => getConfiguracionNotificaciones(),
        staleTime: 0, // nulo
        placeholderData: {
            data: {}
        }
    });

    return {
        configuracionNotificacionesQuery,
    }
}